import React, {useMemo} from "react";
import {CloseRounded, SettingsRounded} from "@mui/icons-material";
import {EndActionType} from "../index";
import {useTranslation} from "react-i18next";
import {usePanel} from "../../../layout";

const useSettingsEndAction = (): EndActionType => {
    const {drawersOpenState, setDrawersOpenState} = usePanel();
    const {t} = useTranslation("components", {keyPrefix: 'panel-sections.app-bar.actions.settings'});
    const settingsDrawerOpen = drawersOpenState.settingsDrawer;

    /**
     * Opens the settings drawer.
     */
    const toggleSettingsDrawer = React.useCallback(() => {
        setDrawersOpenState(prevState => ({...prevState, settingsDrawer: !prevState.settingsDrawer}));
    }, [setDrawersOpenState]);

    return useMemo<EndActionType>(() => ({
        key: "settingsDrawer",
        title: settingsDrawerOpen ? t(t => t.close) : t(t => t.open),
        sx: {
            "@keyframes rotate-settings-drawer": {
                "0%": {transform: "rotate(0deg)"},
                "100%": {transform: "rotate(180deg)"}
            },
            svg: {
                animation: "rotate-settings-drawer 8s linear infinite"
            }
        },
        icon: settingsDrawerOpen
            ? <CloseRounded/>
            : <SettingsRounded/>,
        color: "primary" as const,
        onClick: toggleSettingsDrawer,
    }), [settingsDrawerOpen, toggleSettingsDrawer, t])

}

export default useSettingsEndAction;
